<template>
  <el-dialog title="更换房间"
             :visible.sync="showModal"
             @close="handleCancel"
             :close-on-click-modal="false"
             width="40%">
    <el-card shadow="none">
      <el-col :span="24">
        <el-form :model="changeData"
                 :rules="changeRules"
                 ref="changeForm"
                 label-width="125px"
                 class="change-form">

          <el-form-item label="所属区域:"
                        prop="area_id">
            <el-select v-model="changeData.area_id"
                       placeholder="请选择所属区域"
                       @change="areaSelChange()">
              <el-option v-for="item in areaList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="设备权限:"
                        prop="lock_id">
            <el-select v-model="changeData.lock_id"
                       placeholder="请选择设备">
              <el-option v-for="item in lockList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

        </el-form>
      </el-col>
    </el-card>

    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary"
                 @click="handleConfirm('changeForm')">确 定</el-button>
    </span>

  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      id: '',
      area_id: '',
      lock_id: '',
      o_lock_id: '',
      medvalue: ''
    },
    areaList: {}
  },
  data() {
    return {
      showModal: this.isShow,
      lockList: [],
      changeData: {
        id: '',
        area_id: '',
        lock_id: '',
        o_lock_id: '',
        medvalue: ''
      },
      changeRules: {
        area_id: [{ required: true, message: '请输选择所属区域' }],
        lock_id: [{ required: true, message: '请输选择设备' }]
      }
    }
  },
  created() {
    this.changeData.id = this.data.id
    this.changeData.area_id = this.data.area_id
    this.changeData.lock_id = this.data.lock_id
    this.changeData.o_lock_id = this.data.lock_id
    this.changeData.medvalue = this.data.medvalue
    this.getInfo()
    this.changeData.lock_id = this.data.lock_id
  },
  methods: {
    //获取原始信息
    getInfo() {
      fetch
        .getLockList({ perPage: 0, currentPage: 0, type: 'old', area_id: this.changeData.area_id })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.lockList = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },

    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          fetch.hotelChange({ ...this.changeData }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.$message.success('操作成功')
                this.handleCancel('refresh')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        } else {
          return false
        }
      })
    },
    handleCancel(val) {
      this.$emit('handleClose', val)
    },
    //区域选择联动设备筛选
    areaSelChange() {
      this.lockList = []
      this.changeData.lock_id = ''
      fetch
        .getLockList({ perPage: 0, currentPage: 0, type: 'old', area_id: this.changeData.area_id })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.lockList = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    }
  }
}
</script>

<style></style>
